import { priceListActionTypes } from '@Actions/inventory/priceListActions';

const PriceListReducers = (state = { }, action) => {
  switch (action.type) {
  case priceListActionTypes.GET_PRICE_LISTS.LOADING: {
    const { getPriceListsLoading } = action;
    return {
      ...state,
      getPriceListsLoading,
    };
  }
  case priceListActionTypes.GET_PRICE_LISTS.SUCCESS: {
    const { priceLists } = action;
    return {
      ...state,
      priceLists,
    };
  }
  case priceListActionTypes.GET_APPLY_PRICE_LISTS.LOADING: {
    const { getApplyPriceListLoading } = action;
    return {
      ...state,
      getApplyPriceListLoading,
    };
  }
  case priceListActionTypes.GET_APPLY_PRICE_LISTS.SUCCESS: {
    const { applyPriceLists } = action;
    return {
      ...state,
      applyPriceLists,
    };
  }
  case priceListActionTypes.GET_PRICE_LIST_BY_ID.LOADING: {
    const { getPriceListByIdLoading } = action;
    return {
      ...state,
      getPriceListByIdLoading,
    };
  }
  case priceListActionTypes.GET_PRICE_LIST_BY_ID.SUCCESS: {
    const { selectedPriceList } = action;
    return {
      ...state,
      selectedPriceList,
    };
  }
  case priceListActionTypes.CREATE_PRICE_LIST.LOADING: {
    const { createPriceListLoading } = action;
    return {
      ...state,
      createPriceListLoading,
    };
  }
  case priceListActionTypes.UPDATE_PRICE_LIST.LOADING: {
    const { updatePriceListLoading } = action;
    return {
      ...state,
      updatePriceListLoading,
    };
  }
  case priceListActionTypes.UPDATE_STATUS_PRICE_LIST.LOADING: {
    const { updatePriceListStatusLoading } = action;
    return {
      ...state,
      updatePriceListStatusLoading,
    };
  }
  case priceListActionTypes.DELETE_PRICE_LIST.LOADING: {
    const { deletePriceListLoading } = action;
    return {
      ...state,
      deletePriceListLoading,
    };
  }
  case priceListActionTypes.GET_CUSTOM_PRICE_LIST.LOADING: {
    const { getCustomPriceListLoading } = action;
    return {
      ...state,
      getCustomPriceListLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default PriceListReducers;
